import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const updateProductFunc = createAsyncThunk(
    "updateProduct",
    async ({ id, data }, thunkAPI) => {
        try {
            const response = await api.put(`dashboard/products/${id}`, data);
            return response.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
)

const updateProductSlicer = createSlice({
    name: "updateProduct",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(updateProductFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        });
        builder.addCase(updateProductFunc.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.apiErrors = action.payload?.errors || {};
        });
        builder.addCase(updateProductFunc.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.successMessage = action.payload?.message || "";
        });
    }
});

export default updateProductSlicer.reducer;